export default "__VITE_ASSET__BUdiJEXU__"